export const language = {
  defaults: {
    results_per_page: 'Results per page',
    back_to_home: 'Back to home',
    close: 'Close',
    open_file: 'Open file',
  },
  pages: {
    profileSettings: {
      title: 'Settings',
      notifications: 'Notifications',
      yourData: 'Your data',
      logout: 'Logout',
      placeholders: {
        name: 'Name',
        surname: 'Surname',
        email: 'Email',
        phone: 'Phone number',
        nation: 'Nation',
        province: 'Province',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password'
      },
      switches: {
        apps: 'Email notifications about applications sent',
        new: 'Email notifications for new open positions'
      },
      buttons: {
        save: 'Save',
        changePassword: 'Change password',
        logout: 'Log out'
      },
      back: 'Back'
      ,
      passwordModal: {
        title: 'Change password'
      }
    },
    recover: {
      title: 'Reset password',
      emailLabel: 'Your email',
      sendCode: 'Send code',
      otpTitle: 'We sent you an OTP code',
      otpDesc: 'Open your email and enter the OTP code below.',
      otpPlaceholder: 'OTP code',
      resendOtp: 'Resend OTP code',
      verifying: 'Verifying…',
      verify: 'Verify',
      newPassword: 'New password',
      confirmPassword: 'Confirm password'
    },
    addressInput: {
      placeholder: 'Enter an address',
      save: 'Save',
      close: 'Close'
    },
    jobApplyReview: {
      modal: {
        title: 'Application sent successfully!',
        body: 'We have just sent you a confirmation email',
        close: 'Close'
      }
    },
    profile: {
      greeting: 'Hello,',
      applied: 'Applications',
      favourites: 'Favorites',
      searchPlaceholder: 'Search by name...',
      noApplied: 'No applications.',
      noFavourites: 'No favorites.',
      exploreLink: 'Explore open positions',
      settingsAria: 'Settings'
    },
    jobExplore: {
      title: 'Open positions',
      results: 'results',
      noResults: 'No open positions found matching the current filters.',
      noResultsEmpty: 'There are no open positions at the moment. Please check back later.',
      filters: {
        country: 'Country',
        site: 'Work location',
        sector: 'Sector',
        role: 'Role',
        searchPlaceholder: 'Search by name...',
        applied: 'Active filters',
        labelCountry: 'Country',
        labelSite: 'Site',
        labelSector: 'Sector',
        labelRole: 'Role',
        labelSearch: 'Search'
      },
      pagination: {
        perPage: 'Results per page'
      }
    },
    jobDetail: {
      back: 'Back',
      applyNow: 'Apply now',
      appliedAlready: 'Application already sent',
      notOpen: 'This position is no longer open',
      description: 'Description',
      workplace: 'Workplace',
      country: 'Country',
      role: 'Role',
      sector: 'Sector'
    },
    jobApply: {
      applyingFor: 'Applying for:',
      cancel: 'Cancel',
      next: 'Next',
      steps: {
        loginRegister: 'Login / Registration',
        additionalData: 'Additional data',
        reviewAndSend: 'Review and send'
      },
      position: 'Position',
      filePlaceholder: 'No file selected',
      uploadFile: 'Upload file',
      removeFile: 'Remove',
      fileTooLarge: 'The file exceeds the maximum allowed size'
    },
    jobApplyReview: {
      sending: 'Sending…',
      submit: 'Submit',
      emptyError: 'Please add at least one answer',
      duplicateError: 'You have already submitted an application for this position.',
      privacyTitle: 'PRIVACY POLICY ACKNOWLEDGEMENT',
      privacyBodyHtml: 'I have read and understood the content of the <a href="https://www.cimolai.com/en/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a> and the <a href="/privacy-candidati" target="_blank" rel="noreferrer">Privacy Policy for Candidates</a>, provided pursuant to Regulation (EU) 2016/679',
      modal: {
        title: 'Application sent successfully!',
        body: 'We have just sent you a confirmation email',
        close: 'Close'
      }
    },
    login: {
      heading: 'Enter the CIMOLAI world',
      login: 'Login',
      register: 'Registration',
      usernamePlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      phone: 'Phone number',
      country: 'Country of residence',
      province: 'Province of residence',
      password: 'Password',
      passwordRepeat: 'Repeat password',
      notificationsApps: 'Email notifications about applications sent',
      notificationsNew: 'Email notifications for new open positions',
      privacyAcceptance: 'PRIVACY POLICY ACCEPTANCE',
      adultDeclaration: 'I DECLARE THAT I AM OF AGE',
      registerCta: 'Register',
      registering: 'Registering…'
    },
    reset: {
      key: 'Code',
      password: 'Password',
      confirmPassword: 'Confirm password',
      submit: 'Submit'
    },
    home: {
      emailPlaceholder: 'Email address'
    },
    register: {
      name: 'Name',
      surname: 'Surname',
      email: 'Email address',
      password: 'Password',
      submit: 'Register'
    }
  }
  ,
  headerTexts: {
    explore: 'Explore open positions',
    reserved: 'Reserved area'
  }
  ,
  footerTexts: {
    payoff: 'We have been working with steel with passion since 1949',
    headOffice: 'HEADQUARTERS',
    regOffice: 'REGISTERED OFFICE',
    contactUs: 'CONTACT US',
    followUs: 'FOLLOW US',
    legal: {
      integratedQualityBim: 'Integrated quality and BIM',
      policy: 'Policy',
      codeOfEthics: 'Code of ethics',
      privacyPolicy: 'Privacy Policy',
      privacyPolicyUrl: 'https://www.cimolai.com/en/privacy-policy/',
      cookiePolicy: 'Cookie Policy',
      cookiePolicyUrl: 'https://www.cimolai.com/en/cookie-policy/',
      candidatesPrivacyPolicy: 'Privacy Policy for Candidates',
      integratedPolicy: 'Integrated Policy',
      whistleblowing: 'Whistleblowing',
      rightsReserved: 'All rights reserved'
    }
  }
};
